import { useCollection } from '../hooks/useCollection'
import { Link, NavLink } from 'react-router-dom'

export const ProjectList = () => {
    const { documents, error } = useCollection('projects')
    
  return (
    <div className='my-5 px-4'>
        <h2 className='text-sm font-bold text-white'>ALL PROJECTS</h2>
        {documents && documents.length === 0 && <p>no projects yet</p>}
    {documents && ( documents.map(project => (
        <NavLink activeClassName="text-yellow-500 " exact  to={`/projects/${project.id}`} key={ project.id }>
            <h4 className='py-2' >{ project.name }</h4>
        </NavLink>
    ))

    )}
    {error && <p>{ error }</p> }
    </div>
  )
}
